import {useParams} from 'react-router-dom';
import {Alert} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {FormPageLayout, PlatformEditPageGrid, PlatformLoader} from '@flexinet/ui-components';

import {DetailPageNavigation} from '../navigation/DetailPageNavigation';
import {PricingUnits} from '../profile/PricingUnits';
import {Profile} from '../profile/Profile';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {useProduct} from '../hooks/useProduct';
import config from '../config';

export const DetailPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {record, loading, isError, notFound} = useProduct(id);
    const {tools} = useEditPageTools(record);

    if (loading) {
        return <PlatformLoader message={I18n.get('Loading product...Please wait')}/>;
    }

    // A failed read and a missing product are different answers, and an
    // operator acts on them differently (retry vs. check the id).
    if (isError) {
        return (
            <Alert color='red' title={I18n.get('Could not load the product')}>
                {I18n.get('The marketplace API did not return this product. Reload the page; if it persists the API may be unavailable in this environment.')}
            </Alert>
        );
    }

    if (notFound || !record) {
        return (
            <Alert color='yellow' title={I18n.get('Product not found')}>
                {I18n.get('No product found for id')} <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={`${I18n.get(config.titles.singular)}: ${record.name}`}
            pageNavigation={<DetailPageNavigation component={record}/>}
            tools={tools}
        >
            <PlatformEditPageGrid
                leftContent={<Profile record={record}/>}
                rightContent={<PricingUnits dimensions={record.dimensions}/>}
            />
        </FormPageLayout>
    );
};
